<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-02 11:28:42
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 16:19:03
 * @Description: 鲸鱼大事件
 -->

<template>
  <div class="m-jinr-important-wrapper">
    <div class="jinr-important-content">
      <div class="platform">
        <h2>鲸鱼平台</h2>
        <p>
          鲸鱼专注于互联网+金融模式，运用互联网技术解决金融服务中的用户需求。依托多维度的大数据风控模式，致力为个人、中小微企业提供安全可靠的线上信贷及出借撮合服务。
        </p>
        <div class="m-banner-wrapper">
          <swiper :options="swiperOption1" class="swiper-container">
            <swiper-slide class="banner-item">
              <img src="https://files.jinr.com/jinr-index/img/m-mid-bg-01.png" alt="" />
              <h3>使命</h3>
              <p>为广大人民提供安全稳健的普惠金融服务</p>
            </swiper-slide>
            <swiper-slide class="banner-item">
              <img src="https://files.jinr.com/jinr-index/img/m-mid-bg-02.png" alt="" />
              <h3>理念</h3>
              <p>时间投资哲学的践行者，用时间智慧改变人民生活</p>
            </swiper-slide>
            <swiper-slide class="banner-item">
              <img src="https://files.jinr.com/jinr-index/img/m-mid-bg-03.png" alt="" />
              <h3>使命</h3>
              <p>打造中国最具影响力的新金融生态链</p>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="m-jinr-important-event">
      <h2>鲸鱼大事件</h2>
      <div class="line"><i></i><i></i><i></i></div>
      <div class="swiper-box">
        <swiper :options="swiperOption2" class="m-jinr-important" ref="mySwiper">
          <swiper-slide class="slide-item">
            <p class="date">2014年09月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-00.png" alt="" />
            </div>
            <p class="text">鲸鱼官网正式上线</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2015年01月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-01.png" alt="" />
            </div>
            <p class="text">交易总额突破1亿元</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年04月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-02.png" alt="" />
            </div>
            <p class="text">接入存证云系统（美亚柏科）</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年08月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-03.png" alt="" />
            </div>
            <p class="text">交易总额突破100亿</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2016年12月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-04.png" alt="" />
            </div>
            <p class="text">荣获“中国卓越影响力普惠金融服务机构”大奖</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2017年07月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-05.png" alt="" />
            </div>
            <p class="text">荣获2017中国资产管理金贝奖</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date">2018年09月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-06.png" alt="" />
            </div>
            <p class="text">成为“厦门市地方金融协会”<br />会员单位</p>
          </swiper-slide>
          <swiper-slide class="slide-item">
            <p class="date at-last">2019年5月<i></i></p>
            <div class="img-box">
              <img src="https://files.jinr.com/jinr-index/img/big-event-07.png" alt="" />
            </div>
            <p class="text">接入银行存管系统</p>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="swiper-btn swiper-button-prev"></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-btn swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'jinr-important',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption1: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        slidesPerView: 1.5,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
        // loopedSlides: 5,
      },
      swiperOption2: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 'auto',
        loopedSlides: 3,
        on: {
          // click: function() {
          //   this.autoplay.start();
          // }
        }
      }
    };
  }
};
</script>
<style lang="less">
.m-jinr-important-event {
  position: relative;
  height: 5.38rem;
  width: 100%;
  background: #fff;
  .line {
    position: absolute;
    width: 4.46rem;
    height: 0.04rem;
    background-color: #2c6eff;
    top: 2rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    i {
      width: 0.08rem;
      height: 0.08rem;
      background: #2c6eff;
      -webkit-box-shadow: 1px 2px 10px 0 #2c6eff;
      box-shadow: 1px 2px 10px 0 #2c6eff;
      border-radius: 50%;
      margin-top: -0.02rem;
    }
  }
  h2 {
    font-family: 'PingFangSC-Medium';
    font-size: 0.32rem;
    color: #333333;
    line-height: 1;
    text-align: center;
    padding: 0.4rem 0 0.71rem;
  }
  .swiper-box {
    position: relative;
    width: 6.24rem;
    margin: 0 auto;
    .swiper-btn {
      width: 0.08rem;
      height: 0.25rem;
      color: #979797;
      position: absolute;
      top: 50%;
      outline: none;
      transform: translateY(-50%);
      z-index: 5;
      // margin-top: -0.12rem;
      cursor: pointer;
    }
    .swiper-button-prev {
      left: -0.3rem;
      width: 0.62rem;
      height: 0.8rem;
      background: url('https://files.jinr.com/jinr-index/img/m-swiper-prev.png') no-repeat center
        center;
      background-size: 25%;
    }
    .swiper-button-next {
      right: -0.3rem;
      width: 0.62rem;
      height: 0.8rem;
      background: url('https://files.jinr.com/jinr-index/img/m-swiper-next.png') no-repeat center
        center;
      background-size: 25%;
    }
  }
}
.m-jinr-important {
  margin: 0 auto;
  position: relative;
  background: #fff;
  font-size: 0.22rem;
  .swiper-container {
    width: 6rem;
  }
  .slide-item {
    width: 2.08rem !important;
    height: 3.68rem;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: space-around;
    .date {
      color: #999999;
      position: relative;
      text-align: center;
    }
    .img-box {
      width: 1.38rem;
      height: 1.38rem;
      margin: 0.6rem auto 0.23rem;
      border-radius: 50%;
      background: #ccc;
      overflow: hidden;
      transition: 0.2s linear;
      img {
        width: 100%;
      }
      // &:hover {
      //   opacity: 1;
      //   -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.36);
      //   box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.36);
      // }
    }
    .text {
      text-align: center;
      font-family: 'PingFangSC-Medium';
      font-size: 0.22rem;
      color: #333333;
      line-height: 0.32rem;
    }
  }
}
</style>

<style lang="less" scoped>
.m-jinr-important-wrapper {
  position: relative;
  .jinr-important-content {
    width: 100%;
    height: 6.67rem;
    // margin: 0 auto;
    background-color: #eff3ff;
    box-shadow: 0 10px 14px 0 #e0ebfc;
    .platform {
      margin: 0 auto;
      text-align: center;
      h2 {
        font-family: 'PingFangSC-Medium';
        font-size: 0.32rem;
        line-height: 1;
        color: #333333;
        padding: 0.52rem 0;
      }
      p {
        width: 6.9rem;
        margin: 0 auto;
        font-size: 0.26rem;
        color: #777777;
        line-height: 0.4rem;
        text-align: justify;
      }
      .m-banner-wrapper {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        padding: 0.5rem 0 0 0.12rem;
        .banner-item {
          position: relative;
          width: 4.26rem;
          height: 2.78rem;
          padding: 0 0 0 0.18rem;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
          h3 {
            position: absolute;
            width: 100%;
            font-size: 0.26rem;
            top: 0.52rem;
            text-align: center;
            color: #ffffff;
          }
          p {
            position: absolute;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: 1.13rem;
            width: 2.42rem;
            height: 0.56rem;
            text-align: center;
            font-size: 0.22rem;
            line-height: 0.28rem;
            letter-spacing: 0rem;
            color: #ffffff;
          }
          img {
            display: block;
            width: 100%;
            height: 2.4rem;
            border-radius: 0.12rem;
          }
          .mask {
            width: 100%;
            height: 2.4rem;
            position: absolute;
            top: 0;
            background: rgba(0, 0, 0, 0.4);
            // background-color: #dae3fe;
            border-radius: 0.12rem;
            z-index: 3;
            box-sizing: border-box;
            p {
              position: relative;
              text-indent: 0;
              top: 80px;
              text-align: center;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.m-jinr-important-wrapper {
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 0.1rem;
      height: 0.1rem;
      transform: none;
      border-radius: 100%;
    }
  }
  .swiper-container-horizontal > .swiper-pagination-bullets {
    margin: 0 0.13rem;
    bottom: 0 !important;
    border-radius: 50%;
  }
}
</style>
